module.exports = __webpack_public_path__ + "media/components/country-flag/static/pr-42def60b06105c6f657c82e7959a5812.svg";